import React, { Suspense, lazy, useEffect, useState } from 'react'
import './index.css'
import { Col, Drawer, Layout, Row } from 'antd'
import { Content, Footer, Header } from 'antd/es/layout/layout'
import logo from '../Assets/images/logo.webp'
import logo2 from '../Assets/images/logo2.webp'
import homeBg from '../Assets/images/homeBg.webp'
import homeBgMobile from '../Assets/images/homeBg-mobile.webp'
import homeBg2 from '../Assets/images/homeBg2.webp'
import homeBg2Mobile from '../Assets/images/homeBg2-mobile.webp'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { IoChevronForward, IoMenu } from "react-icons/io5";
import { FaLink, FaHeadset, FaBuilding, FaLock, FaShareNodes, FaCarSide, FaUser } from "react-icons/fa6";
import HeaderDropDown from '../Components/headerDropDown'
import NavbarCurrencySelect from '../Components/navbarCurrencySelect'
import visa from '../Assets/images/payments/visa.webp'
import mastercard from '../Assets/images/payments/mastercard.webp'
import americanExpress from '../Assets/images/payments/american-express.webp'
import discover from '../Assets/images/payments/discover-card.webp'
import paypal from '../Assets/images/payments/paypal.webp'
import fb from '../Assets/images/fb.webp'
import insta from '../Assets/images/insta.webp'
import twitter from '../Assets/images/twitter.webp'
import pintrest from '../Assets/images/pintrest.webp'
import dayjs from 'dayjs'
import HeroSectionSearchFilters from '../Components/heroSectionSearchFilters'
import useGeneralStore from '../Store/generalStore'
import useAuthStore from '../Store/authStore'
import { isTourEnabled } from '../Config/utils/featureFlags';

const SignInSignUpModal = lazy(() => import('../Pages/auth/SignInSignup'));

const items = [
    {
        title: 'Home',
        path: '/',
    },
    {
        title: 'About',
        path: '/about-us',
    },
    {
        title: 'Popular Destinations',
        path: '/popular-destinations',
    },
    {
        title: 'Airport Transfers & Tours',
    },
    {
        title: 'Contact',
        path: '/ContactUs',
    },
    {
        title: 'Partnership',
        path: '/CarRentalFranchise',
    },
]
const TOUR_MENU_ITEMS = ['Popular Destinations', 'Airport Transfers & Tours'];

const dropDownItems = ['/Profile']
const transparentBgRoutes = [
    '/BecomeTourVendor',
    '/ContactUs',
    '/CarRentalFranchise',
    '/about-us',
    '/Profile',
    '/car-listing',
    '/car-detail',
    '/destination-listing',
    '/destination-detail',
    '/popular-destinations',
    '/jamaica-destinations',
    '/PopularDestinations',
    '/destinations',
    '/payment',
    '/locations',
    '/terms-conditions',
    '/faqs',
    '/faqs-tours-transfers',
    '/franchise-opportunity',
    '/loyalty-program',
    '/airport-transfers-in-jamaica',
    '/tours-in-jamaica',
    '/car-rentals-in-jamaica',
    '/car-rentals-in-trinidad',
    '/airport-transfers-in-trinidad',
    '/tours-in-trinidad',
    '/car-rentals-in-tobago',
    '/airport-transfers-in-tobago',
    '/tours-in-tobago',
    '/car-rentals-in-puerto-rico',
    '/airport-transfers-in-puerto-rico',
    '/tours-in-puerto-rico',
    '/car-rentals-in-jacksonville-florida',
    '/airport-transfers-in-jacksonville-florida',
    '/tours-in-jacksonville-florida',
    '/car-rentals-in-barbados',
    '/airport-transfers-in-barbados',
    '/tours-in-barbados',
    '/car-rentals-in-nassau-bahamas',
    '/airport-transfers-in-nassau-bahamas',
    '/tours-in-bahamas',
    '/sitemap',
];
const innerRoutes = ['/car-listing', '/car-detail', '/destination-detail', '/destination-listing', '/payment', '/destinations']
const footerRoutes = ['/locations', '/terms-conditions', '/faqs', '/faqs-tours-transfers', '/franchise-opportunity', '/loyalty-program', '/sitemap', '/popular-destinations']

const AppLayout = ({ children }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const [showDrawer, setShowDrawer] = useState(false);
    const [itemIsActive, setItemIsActive] = useState('Home');
    const [isTransparentBg, setIsTransparentBg] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [searchType, setSearchType] = useState('cars');
    const tourEnabled = isTourEnabled();
    const navItems = tourEnabled
        ? items
        : items.filter((item) => !TOUR_MENU_ITEMS.includes(item.title));
    
    const setHeroSearchType = useGeneralStore((state) => state.setHeroSearchType);

    const { isAuthenticated, initializeAuth } = useAuthStore();
    const isLogin = isAuthenticated;

    // Initialize auth state on mount
    useEffect(() => {
        initializeAuth();
    }, [initializeAuth]);

    // Listen for logout events
    useEffect(() => {
        const handleLogout = () => {
            setShowLoginModal(false);
        };

        window.addEventListener('auth:logout', handleLogout);
        return () => {
            window.removeEventListener('auth:logout', handleLogout);
        };
    }, []);

    useEffect(() => {
        if (location.pathname) {
            if (location.pathname == '/') {
                setItemIsActive('Home');
                setIsTransparentBg(false);
            }
            else {
                // main nav routes cases
                const getPathFromItem = (item) => {
                    if (item.path) {
                        return item.path;
                    }
                    return '/' + item?.title.replaceAll(' ', '').replace('?', '');
                };

                let selectedItem = navItems.find((item) => getPathFromItem(item) == location.pathname);
                if (selectedItem) {
                    setItemIsActive(selectedItem?.title)
                    if (transparentBgRoutes.includes(location.pathname)) {
                        setIsTransparentBg(true);
                    }
                    else {
                        setIsTransparentBg(false);
                    }
                }
                // drop down when user is signed-in cases
                else if (dropDownItems.includes(location.pathname)) {
                    setIsTransparentBg(true);
                    setItemIsActive('')
                }
                // inner routes cases
                else if (innerRoutes.some(route => location.pathname.startsWith(route))) {
                    setIsTransparentBg(transparentBgRoutes.some(route => location.pathname.startsWith(route)));
                    setItemIsActive('');
                }
                // footer routes cases
                else if (footerRoutes.includes(location.pathname)) {
                    setIsTransparentBg(true);
                    setItemIsActive(false)
                }
                // no case match (404 and other content pages)
                else {
                    setItemIsActive('')
                    setIsTransparentBg(true);
                }
            }
        }
    }, [location.pathname])

    const navItemNavigator = (itemTitle) => {
        const navItem = navItems.find((item) => item.title === itemTitle);

        if (itemTitle === 'Airport Transfers & Tours') {
            setHeroSearchType('destinations');
            navigate('/');
        } else if (navItem?.path) {
            navigate(navItem.path);
        } else {
            const selectedItem = itemTitle.replaceAll(' ', '');
            navigate(selectedItem === 'Home' ? '/' : `/${selectedItem}`);
        }
        if (showDrawer) {
            setShowDrawer(false)
        }
    }

    const basicButtonHandler = () => {
        setShowLoginModal(!showLoginModal)
        if (showDrawer) {
            setShowDrawer(false)
        }
    }

    return (
        <>
            <Layout className='h-fit'>
                <Header className='bg-white text-black box-shadow z-40 py-2 px-4 sticky top-0'>
                    <Row align={'middle'} justify={'space-between'}>
                        <Col lg={4} className=''>
                            <img
                                src={logo2}
                                alt='Classique'
                                fetchPriority='high'
                                className='h-12 w-48 object-contain cursor-pointer ml-7'
                                onClick={() => navigate('/')}
                            />
                        </Col>
                        <Col lg={18} className='flex items-center justify-end 1210px:block'>
                            <div className='hidden 1210px:flex items-center justify-around gap-3'>
                                <ul className={`flex items-center w-5/6 gap-6 ${!isLogin && 'justify-evenly'}`}>
                                    {
                                        navItems?.map((item, index) => {
                                            const Icon = item.icon;
                                            return (
                                                <li
                                                    key={index}
                                                    onClick={() => navItemNavigator(item.title)}
                                                    className={`cursor-pointer font-medium text-sm tracking-wide flex items-center gap-1.5 ${item?.title == itemIsActive ? 'active' : ''}`}>
                                                    {Icon ? <Icon className='text-base shrink-0' aria-hidden /> : null}
                                                    {item.title}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                                <div className='flex items-center gap-3 flex-shrink-0'>
                                    <NavbarCurrencySelect />
                                    {
                                        isLogin ?
                                            <HeaderDropDown drawer={false} /> :
                                            <button
                                                type='button'
                                                onClick={basicButtonHandler}
                                                className='flex items-center gap-2 font-medium text-sm text-black hover:opacity-70 bg-transparent border-0 cursor-pointer'
                                            >
                                                <FaUser className='text-base' aria-hidden />
                                                Sign In
                                            </button>
                                    }
                                </div>
                            </div>
                            <div className='1210px:hidden flex items-center gap-3'>
                                <NavbarCurrencySelect size='small' />
                                <IoMenu size={25} onClick={() => setShowDrawer(true)} />
                            </div>
                        </Col>
                    </Row>
                </Header>
                {
                    !isTransparentBg &&
                    <div className='relative hero-bg-wrap'>
                        <img
                            src={searchType === 'cars' ? homeBgMobile : homeBg2Mobile}
                            srcSet={
                                searchType === 'cars'
                                    ? `${homeBgMobile} 1080w, ${homeBg} 1920w`
                                    : `${homeBg2Mobile} 1080w, ${homeBg2} 1920w`
                            }
                            sizes="100vw"
                            width={1920}
                            height={808}
                            alt=''
                            aria-hidden='true'
                            fetchPriority='high'
                            decoding='async'
                            className={`hero-bg-image ${searchType === 'cars' ? 'hero-bg-image--cars' : 'hero-bg-image--tours'}`}
                        />
                        <div className='overlay'></div>
                        <div className='hero-section content flex flex-col items-center justify-center pt-10 sm:pt-14 pb-0'>
                            <HeroSectionSearchFilters bgTypeNotifier={(value) => setSearchType(value)} />
                        </div>
                    </div>
                }
                <Content className='content h-fit bg-[#f3f0f0] pb-6'>
                    <div className=''>
                        {children}
                    </div>
                </Content>
                <Footer className='bg-[#13253F] w-full'>
                    <>
                        <Row className='max-w-[83%] w-full mx-auto mb-4 md:gap-x-6 lg:gap-x-8'>
                            <Col lg={7} md={7} sm={24} xs={24} className='flex flex-col items-center md:items-start gap-1 mb-4 md:mb-0 border-b border-[#FFFFFF26] pb-4 md:border-0 md:pb-0'>
                                <img className='h-12 w-48 object-contain cursor-pointer' src={logo} onClick={() => navigate('/')} alt='Classique' />
                            </Col>
                            <Col lg={4} md={4} sm={12} xs={24} className='flex flex-col gap-2 mb-4 md:mb-0 border-b border-[#FFFFFF26] pb-4 md:border-0 md:pb-0'>
                                <h3 className='text-[#FFFFFFCC] font-semibold flex items-center gap-2'>
                                    <FaLink />
                                    Quick Links
                                </h3>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between border-b border-[#FFFFFF26] pb-2' to={'/about-us'}><span>About Us</span><IoChevronForward /></Link>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between border-b border-[#FFFFFF26] pb-2' to={'/popular-destinations'}><span>Popular Destinations</span><IoChevronForward /></Link>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between pb-2' to={'/sitemap'}><span>Site Map</span><IoChevronForward /></Link>
                            </Col>
                            <Col lg={4} md={4} sm={12} xs={24} className='flex flex-col gap-2 mb-4 md:mb-0 border-b border-[#FFFFFF26] pb-4 md:border-0 md:pb-0'>
                                <h3 className='text-[#FFFFFFCC] font-semibold flex items-center gap-2'>
                                    <FaHeadset />
                                    Customer Support
                                </h3>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between border-b border-[#FFFFFF26] pb-2' to={'/ContactUs'}><span>Contact Us</span><IoChevronForward /></Link>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between border-b border-[#FFFFFF26] pb-2' to={'/faqs'}><span>FAQs Car Rental</span><IoChevronForward /></Link>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between border-b border-[#FFFFFF26] pb-2' to={'/faqs-tours-transfers'}><span>FAQs Tours & Transfers</span><IoChevronForward /></Link>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between pb-2' to={'/terms-conditions'}><span>Terms & Conditions</span><IoChevronForward /></Link>
                            </Col>
                            <Col lg={4} md={4} sm={12} xs={24} className='flex flex-col gap-2 mb-4 md:mb-0 border-b border-[#FFFFFF26] pb-4 md:border-0 md:pb-0'>
                                <h3 className='text-[#FFFFFFCC] font-semibold flex items-center gap-2'>
                                    <FaBuilding />
                                    Business
                                </h3>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between border-b border-[#FFFFFF26] pb-2' to={'/franchise-opportunity'}><span>Car Rental Franchise</span><IoChevronForward /></Link>
                                <Link className='text-[#FFFFFF99] w-full flex items-center justify-between pb-2' to={'/BecomeTourVendor'}><span>Become a Tour Vendor?</span><IoChevronForward /></Link>
                            </Col>
                        </Row>
                        <Row className='bg-[#00000033] max-w-[100%] py-2' justify='center'>
                            <Col span={24} className='max-w-[83%] w-full mx-auto'>
                                <Row align='middle' gutter={[16, 16]} justify='space-between'>
                                <Col lg={11} md={11} sm={12} xs={24} className='order-3 md:order-1 text-center md:text-left'>
                                    <p className='text-[#FFFFFF99]'>Copyright {dayjs()?.year()} Classique. All Rights Reserved</p>
                                </Col>
                                <Col lg={6} md={6} sm={12} xs={24} className='order-1 md:order-2 flex flex-col items-center text-center border-b border-[#FFFFFF26] pb-3 mb-3 md:border-0 md:pb-0 md:mb-0'>
                                    <h3 className='text-[#FFFFFFCC] font-semibold flex items-center justify-center gap-2 mb-1'>
                                        <FaLock />
                                        Secure Payments
                                    </h3>
                                    <div className='flex items-center justify-center gap-2'>
                                        <img src={visa} alt='Visa' loading='lazy' />
                                        <img src={mastercard} alt='Mastercard' loading='lazy' />
                                        <img src={americanExpress} alt='American Express' loading='lazy' />
                                        <img src={discover} alt='Discover' loading='lazy' />
                                        <img src={paypal} alt='PayPal' loading='lazy' />
                                    </div>
                                </Col>
                                <Col lg={7} md={7} sm={12} xs={24} className='order-2 md:order-3 flex flex-col items-center text-center border-b border-[#FFFFFF26] pb-3 mb-3 md:border-0 md:pb-0 md:mb-0'>
                                    <h3 className='text-[#FFFFFFCC] font-semibold flex items-center gap-2 mb-1'>
                                        <FaShareNodes />
                                        Follow Us
                                    </h3>
                                    <div className='flex items-center justify-center gap-2'>
                                        <a href='https://www.facebook.com/profile.php?id=61575416386075' target='_blank' rel='noopener noreferrer'>
                                            <img src={fb} alt='Facebook' loading='lazy' />
                                        </a>
                                        <img src={twitter} alt='Twitter' loading='lazy' />
                                        <a href='https://www.instagram.com/classique_mobility' target='_blank' rel='noopener noreferrer'>
                                            <img src={insta} alt='Instagram' loading='lazy' />
                                        </a>
                                        <img src={pintrest} alt='Pinterest' loading='lazy' />
                                    </div>
                                </Col>
                                </Row>
                            </Col>
                        </Row>
                    </>
                </Footer>
            </Layout>

            <Drawer
                title={
                    <div className='flex items-center justify-center'>
                        {
                            isLogin ?
                                <HeaderDropDown showDrawer={showDrawer} setShowDrawer={setShowDrawer} />
                                :
                                <button
                                    type='button'
                                    onClick={basicButtonHandler}
                                    className='flex items-center gap-2 font-medium text-sm text-black hover:opacity-70 bg-transparent border-0 cursor-pointer'
                                >
                                    <FaUser className='text-base' aria-hidden />
                                    Sign In
                                </button>
                        }
                    </div>
                }
                placement={'right'}
                width={300}
                onClose={() => setShowDrawer(false)}
                open={showDrawer}
            >
                <ul className='flex flex-col items-start gap-8 justify-between w-5/6'>
                    <li className='w-full'>
                        <NavbarCurrencySelect showLabel size='middle' className='w-full' />
                    </li>
                    {
                        navItems?.map((item, index) => {
                            return (
                                <li
                                    key={index}
                                    onClick={() => navItemNavigator(item.title)}
                                    className={`cursor-pointer font-semibold text-sm tracking-wider ${item?.title == itemIsActive ? 'active' : ''}`}>
                                    {item.title}
                                </li>
                            )
                        })
                    }
                </ul>
            </Drawer>
            {
                showLoginModal && (
                    <Suspense fallback={null}>
                        <SignInSignUpModal showLoginModal={showLoginModal} setShowLoginModal={setShowLoginModal} />
                    </Suspense>
                )
            }
        </>
    )
}


export default AppLayout